// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ChangeBranch: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
            <path
                fill="currentColor"
                d="M9 .5H2.25A1.5 1.5 0 0 0 .75 2v9a1.5 1.5 0 0 0 1.5 1.5H9a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 9 .5Zm-3.375 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm2.25 6h-4.5A.376.376 0 0 1 3 9.125c0-1.036.84-1.875 1.875-1.875h1.5c1.035 0 1.875.84 1.875 1.875a.376.376 0 0 1-.375.375Zm3.75-7.5h-.375v2.25h.375A.376.376 0 0 0 12 3.875v-1.5A.375.375 0 0 0 11.625 2Zm0 3h-.375v2.25h.375A.376.376 0 0 0 12 6.875v-1.5A.376.376 0 0 0 11.625 5Zm0 3h-.375v2.25h.375A.375.375 0 0 0 12 9.875v-1.5A.376.376 0 0 0 11.625 8Z"
                opacity=".66"
            />
        </svg>
    );
};

export default React.memo(ChangeBranch);
